import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=0c968f03&scoped=true&lang=pug&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=0c968f03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c968f03",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/mortgages?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231201105121%2Fpages%2Fcompare-mortgages%2F_provider%2F_code%2F_slug.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./_slug.vue?vue&type=custom&index=1&blockType=router"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsMortgagesSummary: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/mortgages/summary.vue').default,WidgetsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/accordion.vue').default,ProductsMortgagesFeatures: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/mortgages/features.vue').default,WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/image.vue').default,ProductsMortgagesCalculation: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/mortgages/calculation.vue').default,ProductsMortgagesFees: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/mortgages/fees.vue').default,WidgetsResultsDisclaimer: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/results/disclaimer.vue').default,SiteAwardsWinner: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/site/awards-winner.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/site/feefo.vue').default})
